// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__JpqQV","rootSuccess":"CompleteLink_rootSuccess__GrcAn","rootFailure":"CompleteLink_rootFailure__20gQG","isDisabled":"CompleteLink_isDisabled__30nNX"};